import React from "react";
import Link from "components/link";
import { Swiper, SwiperSlide } from "components/swiper";
import { Navigation, Mousewheel, Autoplay } from "swiper/modules";
import { ReactComponent as StandardArrow } from "svgs/right-arrow.svg";
import clsx from "clsx/lite";

const NotificationSlider = ({ slides, beigeStyle, showArrows = true, className, textClass, hideNavigation = false }) => {
	if (!slides?.length > 0) return null;

	const isSlider = slides.length > 1;

	const swiperSettings = isSlider
		? {
			loop: true,
			modules: [Navigation, Mousewheel, Autoplay],
			slidesPerView: 1,
			speed: 1400,
			a11y: true,
			mousewheel: {
				enabled: true,
				forceToAxis: true,
			},
			autoplay: {
				delay: 2500,
				disableOnInteraction: false,
			},
			navigation: {
				enabled: showArrows,
				nextEl: ".right-arrow-an",
				prevEl: ".left-arrow-an",
			},
		}
		: {};

	const content = slides.map((slide, index) => (
		<div key={index} className={clsx(textClass, "flex-full-center text-sm h-full")}>
			<Link to={!hideNavigation ? slide.url : null}>{slide.title}</Link>
		</div>
	));

	return (
		<div className={clsx(className, "overflow-hidden", beigeStyle ? "bg-beige text-black" : "bg-black text-white")}>
			{
				isSlider ? (
					<div className="w-full sm:w-100 h-full relative">
						<Swiper {...swiperSettings} className="w-11/12 mx-auto h-full">
							{content.map((slideContent, index) => (
								<SwiperSlide className="font-bold" key={index}>{slideContent}</SwiperSlide>
							))}
						</Swiper>
						{showArrows &&
							<>
								<button className="left-arrow-an" aria-label="left arrow">
									<StandardArrow className={clsx("rotate-180 size-4", !beigeStyle && "invert")} />
								</button>
								<button className="right-arrow-an" aria-label="right-arrow">
									<StandardArrow className={clsx("size-4", !beigeStyle && "invert")} />
								</button>
							</>
						}
					</div>
				) : (
					content
				)
			}
		</div>
	);
};

export default NotificationSlider;